import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { Skeleton as Component } from '@alfalab/core-components/skeleton';
import styles from './index.module.css';
const skeletons = [0, 1, 2, 3, 4, 5];
export const Skeleton = () => (_jsx("div", { className: cn(styles.container), "data-test-id": 'voip-skeleton', children: skeletons.map((i) => (_jsx(Component, { className: styles.item, visible: true }, i))) }));
